import { useEffect, useState } from 'react';

const DEFAULT_MS = 2000;

/**
 * A short-lived marker for "just copied" style feedback: `set(value)` raises
 * it, and it falls back to null after `ms`. A new `set` restarts the clock;
 * unmounting cancels the pending reset. `T` defaults to `true`, so the
 * boolean case reads `const [copied, flash] = useTransientFlag()`.
 */
export function useTransientFlag<T = true>(ms: number = DEFAULT_MS): [T | null, (value: T) => void] {
  const [value, setValue] = useState<T | null>(null);

  useEffect(() => {
    if (value === null) return;
    const timer = window.setTimeout(() => setValue(null), ms);
    return () => window.clearTimeout(timer);
  }, [value, ms]);

  return [value, setValue];
}
